<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <!-- Page Content -->
    <div class="content container-fluid">
      <!-- Page Header -->
      <div class="page-header">
        <div class="row align-items-center">
          <div class="col">
            <h3 class="page-title">Leave ({{ data.first_name }} {{ data.last_name }})</h3>
            <ul class="breadcrumb">
              <li class="breadcrumb-item">Dashboard</li>
              <li class="breadcrumb-item active">Leaves</li>
            </ul>
          </div>
          <div class="col-auto float-end ms-auto d-flex gap-2">
            <a
              href="javascript:void(0);"
              class="btn btn-primary"
              data-bs-toggle="modal"
              data-bs-target="#add_leave"
              @click="openAddLeave"
            ><i class="fa-solid fa-plus me-1"></i> Add Leave</a>
            <button class="btn btn-info text-white" @click="resetFiltersAndLoad">
              All Leaves
            </button>
            <button class="btn btn-secondary" @click="downloadAllLeavesPdf" :disabled="pdfLoading">
              <span v-if="pdfLoading" class="spinner-border spinner-border-sm me-1" role="status"></span>
              All Leaves (PDF)
            </button>
          </div>
        </div>
      </div>
      <!-- /Page Header -->
      <!-- Search Filter -->
      <div class="row filter-row mb-3 align-items-end">
        <div class="col-md-2">
          <div class="input-block mb-3 form-focus position-relative">
            <label class="position-absolute top-0 start-0 ps-2 pt-1 lh-1 text-black"
              style="z-index: 100; font-size: 12px;">From</label>
            <div class="cal-icon" style="z-index: 90;">
              <date-picker v-model="startDate" placeholder="From" class="form-control floating datetimepicker"
                :editable="true" :clearable="false" :inputFormat="'dd/MM/yyyy'" />
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="input-block mb-3 form-focus position-relative">
            <label class="position-absolute top-0 start-0 ps-2 pt-1 lh-1 text-black"
              style="z-index: 100; font-size: 12px;">To</label>
            <div class="cal-icon" style="z-index: 90;">
              <date-picker v-model="endDate" placeholder="To" class="form-control floating datetimepicker" :editable="true"
                :clearable="false" :inputFormat="'dd/MM/yyyy'" />
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="input-block mb-3 form-focus position-relative">
            <v-autocomplete v-model="leaveStatus" :items="['PENDING', 'APPROVED', 'REJECTED']" variant="outlined" density="comfortable" clearable
              label="Leave Status"></v-autocomplete>
          </div>
        </div>
        <div class="col-md-2">
          <div class="input-block mb-3 form-focus position-relative">
            <v-autocomplete v-model="selectedTypeFilter" :items="['ALL', 'SSP', 'SPP', 'SMP', 'ABSENT', 'UNPAID', 'PAID']" variant="outlined" density="comfortable" clearable
              label="Leave Selection"></v-autocomplete>
          </div>
        </div>
        <div class="col-md-2 col-6">
          <a href="javascript:;" class="btn btn-success w-100 mb-3 d-flex justify-content-center align-items-center" style="height: 44px;" @click="userLeaves"> Search </a>
        </div>
        <div class="col-md-2 col-6">
          <a href="javascript:;" class="btn btn-danger w-100 mb-3 d-flex justify-content-center align-items-center" style="height: 44px;" @click="downloadFilteredLeavesPdf" :disabled="pdfLoading">
            <span v-if="pdfLoading" class="spinner-border spinner-border-sm me-1" role="status"></span>
            <span>PDF</span>
          </a>
        </div>
      </div>

      <div class="row filter-row mb-4 align-items-end">
        <div class="col-md-6 col-12">
          <div class="input-block mb-3">
            <input type="text" class="form-control bg-white" readonly :value="'Leave taken ' + rangePaidLeaves + ' days'" style="height: 44px; border: 1px solid #ccc;" />
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="input-block mb-3">
            <input type="text" class="form-control bg-white" readonly :value="'Leave taken (Unpaid) ' + rangeUnpaidLeaves + ' days'" style="height: 44px; border: 1px solid #ccc;" />
          </div>
        </div>
      </div>
      <!-- /Search Filter -->

      <div v-if="!loader">
        <!-- Leave Statistics -->
        <div class="row">
          <div class="col-md-12">
            <div class="bg-white p-3 mb-6">
              <h4 class="">{{ data.first_name + ' ' + data.last_name }}&nbsp;({{
                companyIdToCompanyRole(data.company_role_id) }})</h4>
            </div>
          </div>
          <div class="col-md-3">
            <div class="stats-info">
              <h6>Annual Leave</h6>
              <h4>{{ annualLeaves }}</h4>
            </div>
          </div>
          <div class="col-md-3">
            <div class="stats-info">
              <h6>Paid Leave</h6>
              <h4>{{ paidLeaves }}</h4>
            </div>
          </div>
          <div class="col-md-3">
            <div class="stats-info">
              <h6>Unpaid Leave</h6>
              <h4>{{ unpaidLeaves }}</h4>
            </div>
          </div>
          <div class="col-md-3">
            <div class="stats-info">
              <h6>Remaining Leave</h6>
              <h4>{{ annualLeaves - paidLeaves }}</h4>
            </div>
          </div>
        </div>
        <!-- /Leave Statistics -->

        <div class="row">
          <div class="col-md-12">
            <!-- <div class="showentries mb-3 custom-select ">
              <div class="d-flex align-items-center gap-2"><span>Show</span>
                <select style="outline: none" v-model="perPage" @change="userLeaves">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <span>entries</span>
              </div>
            </div> -->
            <div class="table-responsive">
              <a-table class="stripped table-hover" :columns="columns" :data-source="filteredLeaveData" :pagination="false" :scroll="{ x: 1150 }">
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'leave_master_category_id'">
                    <h6 class="table-avatar">

                      {{ getCategoriesName(record.leave_master_category_id) }}
                    </h6>
                  </template>
                  <template v-if="column.key === 'Status'">
                    <div class="text-center">
                      <div class="action-label">
                        <a class="btn btn-white btn-sm btn-rounded" href="javascript:void(0);">
                          <i :class="record.class"></i>
                          {{ record.status }}
                        </a>
                      </div>
                    </div>
                  </template>
                  <template v-if="column.key === 'Approvedby'">
                    <h2 class="table-avatar">
                      <!--                      <router-link to="/profile/employee-profile">-->
                      <!--                        <img-->
                      <!--                          :src="require(`@/assets/img/profiles/${record.Image}`)"-->
                      <!--                          alt="User Image"-->
                      <!--                      />-->
                      <!--                      </router-link>-->
                      <a href="javascript:;">{{ record.updated_by_user ? (record.updated_by_user.first_name + ' ' + record.updated_by_user.last_name) : (record.status_updated_by ? record.status_updated_by : '--') }}</a>
                    </h2>
                  </template>
                  <template v-else-if="column.key === 'status_updated_at'">
                    {{ record.status_updated_at ? formatDateTimeStandardWithTime(record.status_updated_at) : (record.updated_at ? formatDateTimeStandardWithTime(record.updated_at) : '--') }}
                  </template>
                  <template v-if="column.key === 'action' && showActionButton">
                    <div class="text-end">
                      <div class="dropdown dropdown-action">
                        <a href="javascript:;" class="action-icon dropdown-toggle" data-bs-toggle="dropdown"
                          aria-expanded="false"><i class="material-icons">more_vert</i></a>
                        <div class="dropdown-menu dropdown-menu-right">
                          <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal" data-bs-target="#edit_leave"
                            @click="editClicked(record)"><i class="fa-solid fa-pencil m-r-5"></i> Edit Leave</a>
                          <a v-if="isSicknessCategory(record.leave_master_category_id)" class="dropdown-item" href="javascript:;"
                            data-bs-toggle="modal" data-bs-target="#sick_leave_details_modal"
                            @click="view(record, data.first_name + ' ' + data.last_name)"><i
                              class="fa-solid fa-eye m-r-5"></i>View Details</a>
                          <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal"
                            data-bs-target="#delete_approve" @click="deleteClicked(record.id)"><i
                              class="fa-regular fa-trash-can m-r-5"></i> Delete</a>
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
              </a-table>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center text-center mt-5" v-else>
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
    <!-- /Page Content -->
    <sick-leave-details-modal ref="sickLeave"></sick-leave-details-modal>
    <leaves-admin-modal ref="leaveAdmin" @userLeaves="userLeaves"></leaves-admin-modal>
    <sick-leave-modal ref="sickLeaveModal"></sick-leave-modal>
    <edit-employee-modal ref="editEmployee" @editedUser="userLeaves"></edit-employee-modal>
    <add-face-template-modal ref="addface"></add-face-template-modal>
  </div>
  <!-- /Page Wrapper -->
  <termination-modal></termination-modal>
</template>

<script>
import axios from "axios";
import dayjs from "dayjs";
import { VUE_APP_API_BASE_URL } from "../../../../config";
import { formatDDMMYYYY, calcDays, statusIconClass, formatUSDate, formatDateTimeStandardWithTime } from "@/utils/util-funcitons";
import ActionDropdown from "@/components/action-dropdown.vue";


const columns = [
  {
    title: "Leave Type",
    dataIndex: "type",
    key: "type",
    width: 120,
    sorter: {
      compare: (a, b) => {
        a = a.type.toLowerCase();
        b = b.type.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Category",
    dataIndex: "leave_master_category_id",
    key: "leave_master_category_id",
    width: 140,
  },
  {
    title: "From",
    dataIndex: "start_date",
    width: 120,
    sorter: {
      compare: (a, b) => {
        a = a.start_date;
        b = b.start_date;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "To",
    dataIndex: "end_date",
    width: 120,
    sorter: {
      compare: (a, b) => {
        a = a.end_date;
        b = b.end_date;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "No of Days",
    dataIndex: "no_of_days",
    key: "NoOfDays",
    width: 110,
    sorter: {
      compare: (a, b) => {
        a = a.no_of_days.toLowerCase();
        b = b.no_of_days.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Reason",
    dataIndex: "reason",
    ellipsis: true,
    width: 140,
    sorter: {
      compare: (a, b) => {
        a = a.reason.toLowerCase();
        b = b.reason.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "Status",
    width: 130,
    sorter: {
      compare: (a, b) => {
        a = a.status.toLowerCase();
        b = b.status.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Status Updated by",
    dataIndex: "status_updated_by",
    key: "Approvedby",
    width: 170,
    ellipsis: true,
    sorter: {
      compare: (a, b) => {
        a = a.status_updated_by.toLowerCase();
        b = b.status_updated_by.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Status Updated at",
    dataIndex: "status_updated_at",
    key: "status_updated_at",
    width: 160,
  }
];

export default {
  components: {},
  data() {
    return {
      columns,
      title: "Leaves",
      path: "Dashboard",
      text: "Leaves",
      text1: "Add Leave",
      leaveData: null,
      perPage: 10,
      annualLeaves: null,
      paidLeaves: null,
      unpaidLeaves: null,
      accessToken: [],
      showActionButton: true,
      masterCategoryIds: [],
      data: [],
      companyId: [],
      startDate: new Date(new Date().getFullYear(), 0, 1),
      endDate: new Date(new Date().getFullYear(), 11, 31),
      leaveStatus: null,
      selectedTypeFilter: null,
      loader: false,
      rangePaidLeaves: 0,
      rangeUnpaidLeaves: 0,
      pdfLoading: false
    };
  },
  methods: {
    formatDateTimeStandardWithTime,
    openAddLeave() {
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      const userId = this.$route.query.id || (this.data && this.data.id) || (userInfo && userInfo.user_id);
      if (this.$refs.leaveAdmin && userId) {
        this.$refs.leaveAdmin.setEmployee(userId);
      }
    },
    async getUserData() {
      this.loader = true;
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      const userId = this.$route.query.id || (userInfo && userInfo.user_id);
      if (userId && this.$refs.leaveAdmin) {
        this.$refs.leaveAdmin.setEmployee(userId);
      }
      await axios.get(`${VUE_APP_API_BASE_URL}/user/${this.$route.query.id}`)
        .then((response) => {
          if (response.data.status) {
            this.data = response.data.data;
            if (this.$refs.leaveAdmin && this.data && this.data.id) {
              this.$refs.leaveAdmin.setEmployee(this.data.id);
            }
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },
    async userLeaves() {
      this.loader = true;
      let headers = {
        "Access-Control-Allow-Headers": "*",
        "content-type": "application/json",
        "Accept": "/",
        "Authorization": "Bearer " + localStorage.getItem("accessToken"),
        "ngrok-skip-browser-warning": true
      };
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      const userId = this.$route.query.id || userInfo.user_id;

      if (userId) {
        const params = {
          per_page: this.perPage,
          start_date: dayjs(this.startDate).format('YYYY-MM-DD'),
          end_date: dayjs(this.endDate).format('YYYY-MM-DD')
        };

        if (this.leaveStatus) {
          params.status = this.leaveStatus;
        }

        await axios.get(`${VUE_APP_API_BASE_URL}/leave/${userId}/show`, {
          params: params,
          headers: headers
        }).then((response) => {
          if (response.data.status) {
            this.leaveData = response.data.data.leave_applications;
            this.annualLeaves = (response.data.data.yearly_leaves | 0);
            this.paidLeaves = response.data.data.paid_leaves;
            this.unpaidLeaves = response.data.data.unpaid_leaves;
            this.rangePaidLeaves = response.data.data.range_paid_leaves || 0;
            this.rangeUnpaidLeaves = response.data.data.range_unpaid_leaves || 0;
            this.leaveData.forEach(element => {
              element["no_of_days"] = calcDays(element["start_date"], element["end_date"], element["half_no"]);
              element["start_date_raw"] = element["start_date"];
              element["end_date_raw"] = element["end_date"];
              element["start_date"] = formatDDMMYYYY(element["start_date"]);
              element["end_date"] = formatDDMMYYYY(element["end_date"]);
              element["status_updated_by"] = element["updated_by"] ? element["updated_by"]["first_name"] + ' ' + element["updated_by"]["last_name"] : '-';
              element["class"] = statusIconClass(element["status"]);
            });
          }
        }).catch(function (error) {
          console.log(error);
        }).finally(() => {
          this.loader = false;
        });
      } else {
        this.loader = false;
      }
    },

    async getMasterCategories() {
      await axios.get(`${VUE_APP_API_BASE_URL}/master-category`)
        .then((response) => {
          if (response.data.status) {
            this.masterCategoryIds = response.data.data;
            this.masterCategoryIds.forEach(element => {

              element['text'] = element['name'];
              delete element['name'];
            })
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        });
    },


    editClicked(record) {
      this.$refs.leaveAdmin.updateStatus(record);
    },

    getCategoriesName(id) {
      const name = this.masterCategoryIds.find(item => item.id === id);
      return name ? name.text : '-';
    },

    isSicknessCategory(id) {
      const category = this.masterCategoryIds.find(item => item.id === id);
      if (!category) return false;
      const name = (category.text || '').toLowerCase();
      return name.includes('sick') || name.includes('ssp') || name.includes('smp') || name.includes('spp');
    },

    deleteClicked(id) {
      this.$refs.leaveAdmin.deleteLeave(id);
    },

    view(item, name) {
      this.$refs.sickLeave.updateValues(item, name);
    },

    setAction() {
      this.accessToken = JSON.parse(localStorage.getItem("userInfo"));
      this.showActionButton = this.accessToken?.account_type === 'MEMBER' ? false : true;
      if (this.showActionButton) {
        if (!this.columns.some(column => column.title === "Action")) {
          this.columns.push({
            title: "Action",
            sorter: true,
            key: "action",
            text: "end",
          })
        }

      }
    },
    resetFiltersAndLoad() {
      this.startDate = new Date(new Date().getFullYear(), 0, 1);
      this.endDate = new Date(new Date().getFullYear(), 11, 31);
      this.userLeaves();
    },
    async downloadAllLeavesPdf() {
      this.pdfLoading = true;
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      const userId = this.$route.query.id || userInfo.user_id;
      
      const payload = {
        user_id: userId
      };
      
      await axios.post(`${VUE_APP_API_BASE_URL}/leave-pdf/download`, payload, { responseType: 'blob' })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const name = this.data.first_name && this.data.last_name ? `${this.data.first_name}_${this.data.last_name}` : 'employee';
          link.setAttribute('download', `${name.toUpperCase().replace(/ /g, '_')}_leave.pdf`);
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          this.$toast.error('Download failed');
          console.error(error);
        })
        .finally(() => {
          this.pdfLoading = false;
        });
    },
    async downloadFilteredLeavesPdf() {
      this.pdfLoading = true;
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      const userId = this.$route.query.id || userInfo.user_id;
      
      const payload = {
        user_id: userId,
        start_date: dayjs(this.startDate).format('YYYY-MM-DD'),
        end_date: dayjs(this.endDate).format('YYYY-MM-DD')
      };
      
      await axios.post(`${VUE_APP_API_BASE_URL}/leave-pdf/download`, payload, { responseType: 'blob' })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const name = this.data.first_name && this.data.last_name ? `${this.data.first_name}_${this.data.last_name}` : 'employee';
          link.setAttribute('download', `${name.toUpperCase().replace(/ /g, '_')}_leave.pdf`);
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          this.$toast.error('Download failed');
          console.error(error);
        })
        .finally(() => {
          this.pdfLoading = false;
        });
    },
    companyIdToCompanyRole(id) {
      const company = this.companyId.find(item => item.id === id);
      return company ? company.name : null;
    },

    async getCompanyRoles() {
      await axios.get(`${VUE_APP_API_BASE_URL}/company-role/get`)
        .then((response) => {
          if (response.data.status) {
            this.companyId = response.data.data;
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        });
    },
    attendanceClicked(record) {
      const routeData = this.$router.resolve({ path: '/employee/attendance-employee', query: { id: record.user_id || record.user.id } });
      window.open(routeData.href, '_blank');
    },
    leavesClicked(record) {
      const routeData = this.$router.resolve({ path: '/employee/leaves-employee', query: { id: record.user_id || record.user.id } });
      window.open(routeData.href, '_blank');
    },
    sickLeaveClicked(record) {
      this.$refs.sickLeaveModal.updateValues(record);
    },
    addFaceTemplateClicked(record) {
      this.$refs.addface.updateValues(record);
    },
  },
  computed: {
    filteredLeaveData() {
      if (!this.leaveData) return null;
      if (!this.selectedTypeFilter || this.selectedTypeFilter === 'ALL') {
        return this.leaveData;
      }
      const filter = this.selectedTypeFilter.toUpperCase();
      return this.leaveData.filter(record => {
        const categoryName = (this.getCategoriesName(record.leave_master_category_id) || '').toUpperCase();
        if (filter === 'PAID') {
          return record.is_paid === 1;
        }
        if (filter === 'UNPAID') {
          return record.is_paid === 0;
        }
        if (filter === 'SSP') {
          return categoryName.includes('SSP');
        }
        if (filter === 'SPP') {
          return categoryName.includes('SPP');
        }
        if (filter === 'SMP') {
          return categoryName.includes('SMP');
        }
        if (filter === 'ABSENT') {
          return categoryName.includes('ABSENT') || categoryName.includes('ABSENCE');
        }
        return true;
      });
    }
  },
  mounted() {
    this.userLeaves();
    this.setAction();
    this.getMasterCategories();
    this.getUserData();
    this.getCompanyRoles()
  }
};
</script>
<style scoped>
.custom-select select {
  appearance: none;
  width: 50px;
  font-size: 14px;
  padding: 2px 5px;
  background-color: #fff;
  border: 1px solid #caced1;
  border-radius: 0.25rem;
  color: #000;
  cursor: pointer;
}

/* Fix for dropdown menu being clipped by table-responsive overflow */
.table-responsive {
  overflow-x: auto !important;
  overflow-y: visible !important;
}
</style>
